// SourceChip — small mono badge showing source + age
interface SourceChipProps {
  source: string;
  observedAt: string;
}

function formatAge(dateStr: string): string {
  const date = new Date(dateStr);
  const now = new Date();
  const diffMs = now.getTime() - date.getTime();
  const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

  if (diffDays === 0) return 'today';
  if (diffDays === 1) return '1d ago';
  return `${diffDays}d ago`;
}

export function SourceChip({ source, observedAt }: SourceChipProps) {
  const age = formatAge(observedAt);
  const isStale = new Date().getTime() - new Date(observedAt).getTime() > 14 * 24 * 60 * 60 * 1000;

  return (
    <span className={`source-chip ${isStale ? 'stale' : ''}`} title={`Observed: ${new Date(observedAt).toLocaleString()}`}>
      {source}
      <span style={{ opacity: 0.6 }}>· {age}</span>
    </span>
  );
}
